export default __webpack_public_path__ + "static/media/ic-information.237eafc6.svg";